module.exports = __webpack_public_path__ + "@/assets/img/summaryImage.5d46bb12.png";